// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"313":"5a84d560","475":"c801c260"}[chunkId] + ".css";
};